module.exports = __webpack_public_path__ + "static/media/account.92e73d2e.svg";